import customFetch, { checkForUnauthorizedResponse } from "../../utils/axios";
import { extractFilenameFromContentDisposition, sanitizeFilename } from '../../utils/downloadFilename';
import fileDownload from "js-file-download";

export const exportOrderFactoryThunk = async (url, order, thunkAPI) => {
  console.log("url", url);
  try {
    const resp = await customFetch.get(url, order);
    fileDownload(resp.data, "orders.xlsx");
    return "Orders exported successfully";
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};
export const downloadOrderThunk = async (url, order, thunkAPI) => {
  console.log("url", url);
  try {
    const resp = await customFetch.get(url, order);
    const headers = resp.headers || {};
    const cd = headers['content-disposition'] || headers['Content-Disposition'];
    const ct = headers['content-type'] || 'application/pdf';

    // 1) Try to get filename from header
    let filename = extractFilenameFromContentDisposition(cd);

    // 2) Fallback if header missing or not exposed
    if (!filename) {
      const match = url.match(/orders\/(\d+)/);
      const id = match && match[1];
      filename = id ? `Sales Order ${id}` : 'orders';
    }

    // 3) Sanitize & ensure extension
    filename = sanitizeFilename(filename, { defaultExt: ct.includes('pdf') ? 'pdf' : 'bin' });

    // 4) Download
    // js-file-download signature: fileDownload(data, filename)
    fileDownload(resp.data, filename);

    return `Downloaded ${filename}`;
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};

export const getOrderFactoryThunk = async (url, thunkAPI) => {
  try {
    const resp = await customFetch.get(url);
    return resp.data.data;
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};

export const getOrderThunk = async (url, thunkAPI) => {
  try {
    const resp = await customFetch.get(url);
    return resp.data.data;
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};

export const createOrderThunk = async (url, order, thunkAPI) => {
  try {
    const resp = await customFetch.post(url, order);
    return resp.data;
  } catch (error) {
    return checkForUnauthorizedResponse(error, thunkAPI);
  }
};

export const updateOrderThunk = async (url, order, thunkAPI) => {
  try {
    const resp = await customFetch.post(url, order);
    console.log(resp.data.data);
    return resp.data.data;
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};

export const cancelOrderThunk = async (url, order, thunkAPI) => {
  try {
    const resp = await customFetch.post(url, order);
    return resp.data;
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};

export const removeOrderThunk = async (url, thunkAPI) => {
  try {
    const resp = await customFetch.delete(url);
    return resp.data;
  } catch (error) {
    checkForUnauthorizedResponse(error, thunkAPI);
  }
};
